<template>
    <div class="profile-single">
        <section class="profile__details details">
            <h5 class="profile__title">Dane konta:</h5>

            <div class="details__wrapper">
                <div class="details__data" data-aos="fade-in">
                    <div class="details__avatar">
                        <img class="details__avatar-img" :src="getAvatar()"/>
                        <span class="details__avatar-name">{{ subProfile.name }}</span>
                    </div>

                    <div class="details__data-list">
                        <div class="details__data-item">
                            <span class="details__data-label">Wiek:</span>
                            <span class="details__data-value">{{ subProfile.age }}</span>
                        </div>
                        <div class="details__data-item">
                            <span class="details__data-label">Czas w aplikacji:</span>
                            <span class="details__data-value">{{ subProfile.used_time || 0 }} / {{ perpareTimeLimit(subProfile.game_restriction.time_limit)}}</span>
                        </div>
                        <div class="details__data-item">
                            <span class="details__data-label">Godziny dostępności:</span>
                            <span class="details__data-value">{{ subProfile.game_restriction.play_from }} - {{ subProfile.game_restriction.play_to }}</span>
                        </div>
                        <div class="details__data-item" v-if="subProfile.has_pin">
                            <span class="details__data-label">PIN:</span>
                            <span class="details__data-value">****</span>
                        </div>
                    </div>
                </div>

                <div class="details__edit" @click="this.$emit('editToggle')">
                    <IconEdit class="details__edit-icon"></IconEdit>
                    <span class="details__edit-text">Edytuj profil dziecka</span>
                </div>
            </div>
        </section>

        <section class="profile__activity activity" >
            <h5 class="profile__title">Aktywność:</h5>
            
            <div class="activity__wrapper" v-if="activityVisitList && activityVisitList.length">
                <h6 class="activity__subtitle">Ostatnio podejmowana aktywność</h6>

                <div class="activity__list">
                    <div class="activity__item" v-for="(item, index) in activityVisitList" :key="index">
                        <span class="activity__item-category" v-if="item.breadcrumbs"><span class="activity__item-color" :style="{ 'background-color': item.breadcrumbs[0].color }"></span>{{ item.breadcrumbs[0].title }}</span>
                        <span class="activity__item-title">{{ item.title }}</span>

                        <router-link
                            v-if="item.type !== 'STATION' && item.type !== 'GAME'"
                            class="activity__item-more"
                            :to="{
                                name: generateName(item.type),
                                params: { type: item.type.toUpperCase(), id: item._id, slug: getSlug(item.url)},
                            }"
                        ><span>Zobacz</span><IconEye></IconEye></router-link>

                        <a :href="`${item.breadcrumbs[0].url}?active=${item._id}`" v-if="item.type === 'GAME'" class="activity__item-more"><span>Zobacz</span><IconEye></IconEye></a>
                    </div>              
                </div>
            </div>

            <div class="activity__wrapper" v-else>
                <h6 class="activity__subtitle">Brak zapisanych aktywności</h6>
            </div>

            <div class="activity__wrapper">
                <div class="activity__subheader">
                    <h6 class="activity__subtitle">Czas w aplikacji</h6>

                    <div class="activity__legend">
                        <span class="activity__legend-item">Dziś</span>
                        <span class="activity__legend-item">Średnia ost 7 dni</span>
                    </div>
                </div>

                <ActivityChart :subProfile="subProfile"></ActivityChart>
            </div>
        </section>

        <div class="profile__recommend">
            <h5 class="profile__title">Poleć:</h5>

            <div class="profile__recommend-wrapper">
                <IconFavoriteBig class="profile__recommend-icon"></IconFavoriteBig>
                <span class="profile__recommend-text">Poznaj funcjonalność poleceń - dostepną dla zalogowanych użytkowników. Możesz polecić treść swojemu dziecku dodając ją do ulubionych. Aby to zrobić wyszukaj treść z ekranu głównego i naciśnij serduszko</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { parseImageUrl } from '../../mixins/useParseImage';
import IconEdit from "../elements/icons/IconEdit.vue";
import IconFavoriteBig from "../elements/icons/IconFavoriteBig.vue";
import ActivityChart from "../elements/ActivityChart.vue";
import IconEye from "../elements/icons/IconEye.vue";

export default {
    name: "ProfileSingleData",
    mixins: [parseImageUrl],
    components: {
        IconEdit,
        IconFavoriteBig,
        ActivityChart,
        IconEye
    },
    props: {
        subProfile: {
            type: Object
        }
    },
    data() {
        return {
            ACTIVITY_VISIT: '/api/krainaabc/subprofile/activity/last-visit?device=www',   
            activityVisitList: []
        };
    },      
    methods: {
        getAvatar() {
            return parseImageUrl(this.subProfile.avatar.url, 120,120);
        },
        getActivityVisit() {
            let data = {};
            data['subProfile_id'] = this.subProfile._id;

            axios
                .post(this.ACTIVITY_VISIT, data)
                .then((response) => {
                    if (response.status === 200) {
                        if(response.data && response.data.data && response.data.data.items) {
                            this.activityVisitList = response.data.data.items;
                        } 
                    }
                })            
        },
        perpareTimeLimit(time) {
            if(time === 0) {
                return 'bez limitu';
            } else {
                return time;
            }
        },
        getSlug(url) {
            return url.substring(url.lastIndexOf("/") + 1) 
        },
        generateName(type) {
            if(type) {
                return type[0].toUpperCase() + type.slice(1).toLowerCase();
            }
            return null;
        }        
    },
    mounted() {
        if(this.subProfile) {
            this.getActivityVisit();
        }
    } 
};
</script>